export enum FlowHistoryType {
    STEP = "step",
    SEQUENCE = "sequence",
}
